// src/Config/auth.js
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

export const Auth = () => {
    const handleGoogleSignIn = async () => {
        try {
            const provider = new firebase.auth.GoogleAuthProvider();
            await firebase.auth().signInWithPopup(provider);
            console.log('Auth: User signed in with Google');
            // Redirect to upload.html after successful Google sign-in
            window.location.href = 'upload.html';
        } catch (error) {
            console.error('Google sign-in error:', error.message);
            alert(`Google sign-in failed: ${error.message}`);
        }
    };

    const handleTwitterSignIn = async () => {
        try {
            const provider = new firebase.auth.TwitterAuthProvider();
            await firebase.auth().signInWithPopup(provider);
            console.log('Auth: User signed in with Twitter');
            // Redirect to upload.html after successful Twitter sign-in
            window.location.href = 'upload.html';
        } catch (error) {
            console.error('Twitter sign-in error:', error.message);
            alert(`Twitter sign-in failed: ${error.message}`);
        }
    };

    const handleGithubSignIn = async () => {
        try {
            const provider = new firebase.auth.GithubAuthProvider();
            await firebase.auth().signInWithPopup(provider);
            console.log('Auth: User signed in with GitHub');
            // Redirect to upload.html after successful GitHub sign-in
            window.location.href = 'upload.html';
        } catch (error) {
            console.error('GitHub sign-in error:', error.message);
            alert(`GitHub sign-in failed: ${error.message}`);
        }
    };

    const handleLogout = async () => {
        try {
            await firebase.auth().signOut();
            console.log('Auth: User logged out');
        } catch (error) {
            console.error('Auth: Logout error:', error.message);
            alert(`Logout failed: ${error.message}`);
        }
    };

    return {
        handleGoogleSignIn,
        handleTwitterSignIn,
        handleGithubSignIn,
        logout: handleLogout
    };
};